import { NgModule } from '@angular/core';

import { OAuthCallbackComponent } from './oauth-callback.component';
import { OAuthCallbackHandler } from './oauth-callback.guard';

@NgModule({
    imports: [],
    declarations: [OAuthCallbackComponent],
    providers: [OAuthCallbackHandler]
})
export class OAuthCallbackModule { } 



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/shared/login-callback/oauth-callback.module.ts